import {useState , useEffect} from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import "../displayPosts/display.css";
import MyCard from '../displayPosts/MyCard';
import { toast } from 'react-toastify';

const MyBlogPost = () => {

    const[post , setPost] = useState([]);
    const [searchParams] = useSearchParams();
    const [text,setText] = useState("Loading...");
    let category = searchParams.get("category");
    const token = JSON.parse(sessionStorage.getItem("user")).token;
    const url = "https://my-blog-wzcd.onrender.com";


    async function getPost(){
      try {    
      let arrayOfPost;
      if(category && category !== "all"){
        arrayOfPost  = await axios.get(`${url}/api/post/get-my-post`,{
            headers:{
              Authorization : `Bearer ${token}`
            }
          });
        const filtered = arrayOfPost.data?.posts.filter((post)=> post.category === category);
        if(!filtered.length){
          setText("YOU HAVEN'T POST ANYTHING");
        }
       return setPost(filtered);
      } 
      arrayOfPost  = await axios.get(`${url}/api/post/get-my-post`,{
        headers:{
          Authorization : `Bearer ${token}`
        }
      });
      if(!arrayOfPost.data?.posts?.length){
        setText("YOU HAVEN'T POST ANYTHING");
      }
        setPost(arrayOfPost.data.posts);
      } catch (error) {
        toast.error(error.response.data.message);
      }
    }



    useEffect(()=>{
        getPost()
    },[category])

  return (
    <div className='display-container'>

    {
      post.length ? 
         [...post].reverse().map((singlePost)=>{
        return <MyCard post={singlePost} key={singlePost._id} /> 
        })
     
     : <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}> <p style={{color:"white"}}>{text}</p> </div>
    }
    
 </div>
  )
}

export default MyBlogPost